import { render, staticRenderFns } from "./PhotoSwipe.vue?vue&type=template&id=a2218850"
import script from "./PhotoSwipe.vue?vue&type=script&lang=js"
export * from "./PhotoSwipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports